import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import * as $ from 'jquery';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-client-tasks',
  templateUrl: './client-tasks.component.html',
  styleUrls: ['./client-tasks.component.css']
})

export class ClientComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject<any>();
  spinnerType: string;
  spinnerStyle: any = {};
  setSpinnerStatus: string;
  showSpinner: boolean = true;
  showSmallSpinner: boolean = false;
  smallSpinnerStyle: any = { 'margin-left': '' };
  showNote = null;
  p: number = 1;
  userID;
  orgId;
  comment: string;
  type: any;
  columnData;
  allClientTasks: any = [];
  pageContext: any = [];
  pageContextID: any;
  selectedStatus: string = '';
  selectedClientID: string = '';
  currentClientID: string = '';
  task: any = {};
  taskStatus: string = '';
  isLoading: boolean = false;
  commentLoading: boolean = false;
  payload = {};

  constructor(
    store: Store<AppState>,
    private router: Router,
    private emailService: EmailService,
    private generalTaskSrv: GeneralTaskService,
    private generalSrv: GeneralService
  ) {
    this.spinnerType = "jsBin";
    this.setSpinnerStatus = "";
    this.spinnerStyle = { top: '25%' };
    store.select("userInfo").subscribe(info => {
      this.userID = info.user.id;
      this.orgId = info.organization.id;
    });
  }

  ngOnInit() {
    this.getPageContext()
  }

  /**
  * Description DropDown
  * @param code 
  */
  descipNav(index) {
    this.showNote = index
  }

  /**
   * To pass data from context
   */
  getPageContext() {
    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalSrv.checkIfObjectIsEmpty(context)) {
        this.pageContext = context;
        this.pageContextID = context.data.id
        this.getAssignedTask(context);
      }
    });
  }

  /**
  * Get Assigned task by deal, lead, contact, company , salesperson
  * @param id (Deals, lead, Contacts, Company, Salesperson)
  */
  getAssignedTask(context) {
    this.showSmallSpinner = !this.showSmallSpinner;
    switch (context.name) {
      case 'deal':
        const payloadDeal = {
          dealCode: [context.data.id],
          status: "",
          type: 3,
          userID: [this.userID]
        }
        this.generalTaskSrv.getFilteredTask(payloadDeal).pipe(takeUntil(this.unsubscribe))
          .subscribe(allClientTasks => {
            this.showSmallSpinner = !this.showSmallSpinner;
            this.allClientTasks = allClientTasks;
          })
        break;

      case 'lead':
        const payloadLead = {
          clientID: [context.data.id],
          status: "",
          type: 3,
          userID: [this.userID]
        }
        this.generalTaskSrv.getFilteredTask(payloadLead).pipe(takeUntil(this.unsubscribe))
          .subscribe(allClientTasks => {
            this.showSmallSpinner = !this.showSmallSpinner;
            this.allClientTasks = allClientTasks;
          })
        break;

      case 'company':
        const payloadCompany = {
          clientID: [context.company.clientId],
          status: "",
          type: 3,
          userID: [this.userID]
        }
        this.generalTaskSrv.getFilteredTask(payloadCompany).pipe(takeUntil(this.unsubscribe))
          .subscribe(allClientTasks => {
            this.showSmallSpinner = !this.showSmallSpinner;
            this.allClientTasks = allClientTasks;
          })
        break;

      case 'contact':
        const payloadContact = {
          clientID: [context.contact.clientId],
          status: "",
          type: 3,
          userID: [this.userID]
        }
        this.generalTaskSrv.getFilteredTask(payloadContact)
          .pipe(takeUntil(this.unsubscribe)).subscribe(allClientTasks => {
            this.showSmallSpinner = !this.showSmallSpinner;
            this.allClientTasks = allClientTasks;
          })
        break;

      case 'salesPerson':
        const payload = {
          status: "",
          type: 3,
          userID: [context.data.id]
        }
        this.generalTaskSrv.getFilteredTask(payload).pipe(takeUntil(this.unsubscribe))
          .subscribe(allClientTasks => {
            this.showSmallSpinner = !this.showSmallSpinner;
            this.allClientTasks = allClientTasks;
          })
        break;

      default:
        break;
    }
  }

  statusComment(id,type) {
    document.getElementById('addComment').click();
    this.columnData = id;
    this.type = type;
  }

  createComment() {
    if (!this.type) {
      $(`#closeComment`).click();
      this.generalSrv.sweetAlertError("All Field's are Required")
    } else{
      const payload = {
        comment: this.comment,
        commentCategory: this.type,
        orgID: this.orgId,
        taskID: this.columnData,
        userID: this.userID
      }
      this.commentLoading = true;
      this.generalTaskSrv.commentOnTask(payload).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
        if (this.type == "COMPLETED") {
          this.commentLoading = false;
        $(`#closeComment`).click();
          this.onMarkTaskAsCompleted(this.columnData);
        } else {
          this.commentLoading = false;
        $(`#closeComment`).click();
          this.onMarkTaskAsVoid(this.columnData);
        }
        this.comment = "";
        this.type = "";
      })
    }
    
  }

  /**
  * Mark Task As Complete
  * @param id 
  */
  onMarkTaskAsCompleted(id) {
    this.markTaskAsCompleted(id);
  }

  /**
   * Mark Task As Complete by id
   * @param id 
   */
  private markTaskAsCompleted(id) {
    const status = "COMPLETED"
    this.generalTaskSrv.markTaskStatus(id, status).pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        this.generalSrv.sweetAlertSucess("Your Task As Been Marked As Completed");
        this.getPageContext();
      }, error => {
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  /**
    * Mark Task As Complete
    * @param id 
    */
  onMarkTaskAsVoid(id) {
    this.markTaskAsVoid(id);
  }

  /**
   * Mark Task As Void by id
   * @param id 
   */
  private markTaskAsVoid(id) {
    const status = "VOIDED"
    this.generalTaskSrv.markTaskStatus(id, status).pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        this.generalSrv.sweetAlertSucess("Your Task As Been Terminated");
        this.getPageContext();
      }, error => {
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  /**
   * View 
   * @param id 
   */
  onViewTask(id) {
    this.router.navigate(["/view-my-tasks/" + id]);
    // this.fetchTaskByID(id);
  }

  /**
  * Fetch Task By ID
  * @param id 
  */
  fetchTaskByID(id) {
    this.task = '';
    this.isLoading = true;
    this.generalTaskSrv.getTaskByID(id)
      .pipe(takeUntil(this.unsubscribe)).subscribe(task => {
        this.task = task;
        this.isLoading = false;
      })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
